export const infoHtml = ``
